import React from "react";
import { connect } from "react-redux";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { Field, reduxForm } from "redux-form";
import TextField from 'material-ui/TextField';
import { goTo } from "../tools";
import "./mi-perfil.css";

let opcion4 = false;
let contador = 0;
let value1 = false;
let value2 = false;
let value3 = false;
let value4 = false;

const mapState = (state) => {
    return {
        pasoEliminar: state.miPerfil.pasoEliminar,
        opcion: state.miPerfil.opcion,
        razon: state.miPerfil.razon
    };
};

const mapDispatch = (dispatch) => {
    return {
        pasoSiguiente: () => {
            dispatch({ "type": "MI_PERFIL_PASO_SIGUIENTE_ELIMINAR" });
        },
        guardarOpcion: (op) => {
            dispatch({ "type": "MI_PERFIL_GUARDAR_OPCION", "opcion": op });
        },
        guardarRazon: (razon) => {
            dispatch({ "type": "MI_PERFIL_GUARDAR_RAZON", "razon": razon });
        }
    };
};

const campoSettings = {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 'normal',
    mixBlendMode: 'normal',
}

const floatingLabelStyleSettings = {
    ...campoSettings,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    color: '#0C2040',
}

const floatingLabelFocusStyleSettings = {
    ...campoSettings,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    color: '#FF6B0B',
}

const campo = ({ input, label, max, type, focus, blur, change, error }) => {
    return (
        <MuiThemeProvider>
            <TextField
                {...input}
                id="standard-multiline-static"
                value={input.value}
                name={input.name}
                floatingLabelText={label}
                fullWidth
                multiline
                variant="filled"
                underlineStyle={{ borderColor: '#AAC3EE' }}
                underlineFocusStyle={{ borderColor: '#FF6B0B' }}
                floatingLabelStyle={floatingLabelStyleSettings}
                floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
                type={type}
                rowsMax="3"
                maxLength={max}
                errorText={error}
            />
        </MuiThemeProvider>
    );
};

const handleKeyPress = () => {
    document.getElementsByName("razon")[0].blur();
    document.getElementsByName("confirmaContrasenia")[0].focus();
}

class opcionesEliminarCuenta extends React.Component {
    state = {
        razon: "",
    }

    cancelar = (sRuta) => {
        goTo(sRuta);
    }

    handleChange = e => {
        const { value } = e.target;
        value1 = false;
        value2 = false;
        value3 = false;
        value4 = false;
        this.handleValue(value)
        this.props.guardarOpcion(value);
        if (e.target.value === "op4") {
            opcion4 = true
        } else {
            opcion4 = false
        }
    };

    handleValue = (valor) => {
        for (let index = 1; index < 5; index++) {
            if (valor === "op" + index) {
                switch (index) {
                    case 1:
                        value1 = true;
                        this.props.change("razon", "");
                        this.props.guardarRazon("");
                        contador = 0;
                        break;
                    case 2:
                        value2 = true;
                        this.props.change("razon", "");
                        this.props.guardarRazon("");
                        contador = 0;
                        break;
                    case 3:
                        value3 = true;
                        this.props.change("razon", "");
                        this.props.guardarRazon("");
                        contador = 0;
                        break;
                    case 4:
                        value4 = true;
                        break;
                }
            }
        }
    }

    siguiente = () => {
        this.props.pasoSiguiente();
    }

    handleChangeRespuesta = e => {
        const { value } = e.target;
        contador = value.length;
        this.props.guardarRazon(value);
    }

    componentDidMount = () => {
        this.props.change("razon", this.props.razon);
    }

    render() {
        return (
            <div className="div-elimina-cuenta" style={{height: "450px" }}>
                <div className="txt-center">
                    <div id="title-Registro" className="div-titulo-eliminar">
                        <span className="material-icons bi bi-arrow-left"
                            style={{ float: "left", cursor: "pointer", marginTop: "20px" }}
                            onClick={this.cancelar.bind(this, "mi-perfil")}>
                            arrow_back
                        </span>
                        <label id="txt-titulo-eliminar">Eliminar cuenta</label>
                        <br />
                        <hr className="label-hr" />
                    </div>
                    <div className="contenedor-opciones">
                        <div className="subtitulo">
                            Selecciona una opción
                        </div>
                        <div className="div-titulo-pregunta">
                            <span className="titulo-pregunta">¿Por qué deseas eliminar tu cuenta?</span>
                        </div>
                        <div className="radios" onChange={this.onChangeValue}>
                            <div className="div-opcion">
                                <div className="div-1">
                                    <input type="radio"
                                        value="op1"
                                        name="opcion"
                                        className="inputEC"
                                        onChange={this.handleChange}
                                        checked={value1} />
                                </div>
                                <div className="div-2">
                                    <span className="opcion">Ya no tengo Pólizas contratadas</span>
                                </div>
                            </div>
                            <div className="div-opcion">
                                <div className="div-1">
                                    <input type="radio"
                                        value="op2"
                                        name="opcion"
                                        className="inputEC"
                                        onChange={this.handleChange}
                                        checked={value2}
                                    />
                                </div>
                                <div className="div-2">
                                    <span className="opcion">No utilizo los medios digitales GNP</span>
                                </div>
                            </div>
                            <div className="div-opcion">
                                <div className="div-1">
                                    <input type="radio"
                                        value="op3"
                                        name="opcion"
                                        className="inputEC"
                                        onChange={this.handleChange}
                                        checked={value3}
                                    />
                                </div>
                                <div className="div-2">
                                    <span className="opcion">Por seguridad de mi información</span>
                                </div>
                            </div>
                            <div className="div-opcion">
                                <div className="div-1">
                                    <input type="radio"
                                        value="op4"
                                        name="opcion"
                                        className="inputEC"
                                        onChange={this.handleChange}
                                        checked={value4}
                                    />
                                </div>
                                <div className="div-2">
                                    <span className="opcion">Otro</span>
                                </div>
                            </div>
                        </div>
                        <div>
                            {opcion4 === false ? null :
                                <div className="div-otro">
                                    <Field
                                        name="razon" max="500" component={campo}
                                        label="Escribe la razón"
                                        onChange={this.handleChangeRespuesta}
                                    />
                                    <div className="contador">
                                        <span> {contador}/500</span>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="col-md-6" style={{background: "white", marginLeft: "24%", marginBottom: "10px" }}>
                            <button id="btn-continuar-cambioPass"
                                style={{ width: '120px', height: '48px', fontSize: '16px', padding: '14px 16px' }}
                                className="orange-rectangle" onClick={this.siguiente}>Continuar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
opcionesEliminarCuenta = reduxForm({ form: "opciones" })(opcionesEliminarCuenta);
export default connect(mapState, mapDispatch)(opcionesEliminarCuenta);



// WEBPACK FOOTER //
// ./src/miPerfil/opcionesEliminarCuenta.cmpt.js